export default "__VITE_ASSET__BzFb2j5n__"